export default __webpack_public_path__ + "static/14-077b1abaa7de38e56deb291438e8096b.webp";